'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isDate;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isDate.js
// module id = 809
// module chunks = 0